<template>
  <div class="mycontent">
    <pctop v-show="!isPhone" ref="pctop" @headtop="headpctop"></pctop>
    <div class="bscroll" ref="bscroll" :class="{'pcList': !isPhone}">
      <div class="bscroll-container">
        <div class="itemcontent">
          <p class="nodatalist" v-if="nodatalist">暂无数据</p>
          <div class="itembox1" v-for="(item, index) in List" :key="index">
            <div class="info infoborbottom">
              <span class="fl">{{item.username | userpattern}}</span>
              <span class="fr">{{item.crtTime | crtymd }}</span>
            </div>
            <div class="txt">
              <label v-if="item.leaveWordType !== undefined && item.leaveWordType !== ''">{{item.leaveWordType}}</label>
              <div class="con" v-html="item.fold ? maxSclice(item.content) : item.content"></div>
              <span v-show="isfold(item.content)" class="more" @click="morechange(item)">{{item.fold ? '展开' : '收起'}}</span>
            </div>
            <ul>
              <li v-for="imgitem in item.imagePath" :key="imgitem" v-if="imgitem != ''"><a href="javascript:;"><img :preview="index" :src="imgitem" alt=""></a></li>
            </ul>
            <div class="fun">
              <span class="fl" :class="{ 'no': item.status === '未审核' }">{{item.status}}</span>
              <span class="fr delete" @click.stop="deletefun(item.id)"></span>
            </div>
          </div>
          <div class="listpage" v-show="listshow">
            <el-pagination
              background
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              :total="total">
            </el-pagination>
          </div>
          <p class="drop-down" v-if="nodata">无更多数据</p>
        </div>
      </div>
    </div>
    <div class="pop" ref="pop">
      <div class="popbox">
        <h2>确定要删除么？</h2>
        <div class="spanbtnbox">
          <span @click.stop="qx">取消</span>
          <span @click.stop="complete(deleteId, typeList)" v-if="typeList&&typeList.length>0">完成</span>
        </div>
      </div>
    </div>
    <menus v-show="isPhone"></menus>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Menus from '@/views/common/menus'
import BScroll from 'better-scroll'
import Pctop from '@/views/common/pctop'
Vue.use(preview)
export default {
  name: 'mymessage',
  filters: {
    // 格式化手机号 中间以**代替
    userpattern (val) {
      let strVal = val.toString()
      return `${strVal.substring(0, 3)}****${strVal.substring(strVal.length - 4)}`
    },
    // 显示年月日
    crtymd (val) {
      let arrayVal = val.split(' ')
      return arrayVal[0]
    }
  },
  components: {
    Menus,
    Pctop
  },
  data () {
    return {
      List: [],
      fold: true,
      maxLength: 55,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      typeList: [],
      nodatalist: false,
      deleteId: '',
      isPhone: true,
      screenWidth: '',
      listshow: false,
      nodata: false
    }
  },
  created () {
  },
  watch: {
    typeList (val) {
      if (this.screenWidth < 768) {
        this.getList(val)
        this.scrollFn(val)
      } else {
        this.getList(val)
      }
    }
  },
  mounted () {
    let _this = this
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
      this.listshow = false
    } else {
      this.isPhone = false
      this.listshow = true
      this.$nextTick(() => {
        _this.$refs.pctop.headerHeight()
      })
    }
    this.gettypeList()
  },
  methods: {
    headpctop (val) {
      console.log(val)
    },
    morechange (item) {
      item.fold = !item.fold
    },
    maxSclice (v) {
      if (!this.isPhone) {
        this.maxLength = 75
      } else {
        this.maxLength = 55
      }
      return v.length > this.maxLength ? v.slice(0, this.maxLength) + '...' : v
    },
    gettypeList () {
      // 获取tab 词典表中的留言类型
      this.$http({
        // url: this.$http.adornUrl(`/api/leave-message/front/dict`),
        url: this.$http.adornUrl(`/api/leave-message/front/dict?parentCode=leaveMessage.type`),
        method: 'get'
      }).then((res) => {
        if (res.data.rel === true) {
          let data = res.data.data
          this.typeList = data
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    handleSizeChange (val) {
      // console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
    },
    handleCurrentChange (val) {
      console.log(val)
      this.pageNum = val
      this.getList(this.typeList)
      this.$nextTick(() => {
        this.$refs.indexlist.scrollTo(0, 0)
      })
    },
    getList (val) {
      this.$http({
        // url: this.$http.adornUrl(`/api/leave-message/front/mine`),
        url: this.$http.adornUrl(`/api/leave-message/front/mine?page=` + this.pageNum + `&limit=` + this.pageSize + `&museumCode=` + this.$cookie.get('museumCode')),
        method: 'get'
      }).then((res) => {
        if (res.data.status === 200) {
          let data = res.data.data.rows
          this.total = res.data.data.total
          if (this.total === 0) {
            this.nodatalist = true
            this.List = []
            this.listshow = false
            return false
          } else {
            this.nodatalist = false
            for (let i = 0; i < data.length; i++) {
              // 图片添加路径
              if (data[i].imagePath !== undefined) {
                if (data[i].imagePath !== '') {
                  let imagesArray = ''
                  if (data[i].imagePath.indexOf('|') > -1) {
                    imagesArray = (data[i].imagePath || '').split('|')
                  } else {
                    imagesArray = [data[i].imagePath]
                  }
                  data[i].imagePath = imagesArray
                } else {
                  delete data[i].imagePath
                }
              }
              // 词典type转为相应name展示
              for (let k = 0; k < val.length; k++) {
                if (val[k].dictCode === data[i].leaveWordType) {
                  data[i].leaveWordType = val[k].dictName
                }
              }
              data[i].fold = true
            }
            if (this.screenWidth < 768) {
              this.listshow = false
              if (this.pageNum === 1) {
                this.List = ''
                this.List = data
              } else {
                this.List = this.List.concat(data)
              }
            } else {
              this.listshow = true
              this.List = ''
              this.List = data
            }
            this.$previewRefresh()
          }
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    deletefun (val) {
      this.$refs.pop.style.display = 'block'
      this.deleteId = val
    },
    qx () {
      this.$refs.pop.style.display = 'none'
    },
    complete (val, arr) {
      this.$refs.pop.style.display = 'none'
      this.pageNum = 1
      this.$http({
        url: this.$http.adornUrl(`/api/leave-message/front/del/` + val),
        method: 'delete'
      }).then((res) => {
        if (res.data.rel === true) {
          this.getList(arr)
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    isfold (val) {
      if (val.length < 50) {
        return false
      } else {
        return true
      }
    },
    // 上拉加载
    scrollFn (val) {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.bscroll, {
          click: true,
          scrollY: true,
          probeType: 3
        })
      } else {
        this.scroll.refresh()
      }
      this.scroll.on('scroll', (pos) => {
      })
      // touchEnd（手指离开以后触发） 通过这个方法来监听下拉刷新
      this.scroll.on('touchEnd', (pos) => {
        // 上拉加载 总高度>下拉的高度+10 触发加载更多
        if (this.scroll.maxScrollY > pos.y + 10) {
          let pagetotal = Math.ceil(this.total / this.pageSize)
          if (this.pageNum < pagetotal) {
            this.pageNum++
            this.getList(val)
          } else {
            this.nodata = true
          }
          this.scroll.refresh()
        }
      })
    }
  }
}
</script>

<style lang="scss">
*{touch-action: none;}
.fl{
  float: left;
}
.fr{
  float: right;
}
.mycontent{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.bscroll{
  width: 100%;
  height: 100%;
  overflow: hidden;
  .itemcontent{
    width: 100%;
    padding: 20px 20px 100px;
  }
  .nodatalist{
    text-align: center;
    padding: 100px 20px 0;
    font-size: 18px;
  }
  .itembox1{
    background: #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    padding: 15px 15px 10px;
    margin-bottom: 15px;
    &:last-child{
      margin-bottom: 0;
    }
    .txt{
      position: relative;
      label{
        position: relative;
        padding: 2px 5px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        border: solid 1px #dcdcdc;
        color: #a11b00;
        font-size: 12px;
        margin-right: 8px;
        &:after{
          position: absolute;
          display: block;
          content: '';
          width: 1px;
          height: 14px;
          background: #acacac;
          right: -8px;
          top: 2px;
        }
      }
      .con{
        display: inline;
        line-height: 22px;
      }
      .more{
        float: right;
        line-height: 24px;
        color: #a11b00;
        margin-right: 2px;
        cursor: pointer;
      }
    }
    ul{
      margin: 0 -5px;
      padding: 10px 0;
      &::after{
        content:'';
        display:block;
        clear:both;
        height:0;
        visibility:hidden;
        font-size:0;
      }
      li{
        width: 12.5%;
        float: left;
        padding: 5px;
        a{
          display: block;
          width: 100%;
          border-radius: 6px;
          height: 0;
          padding-bottom: 100%;
          overflow: hidden;
          position: relative;
          img{
            vertical-align: top;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: 50%;
            position: absolute;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .info{
      &.infoborbottom{
        border-bottom: solid 1px #f1f1f1;
        padding: 0px 0 8px;
        margin-bottom: 15px;
      }
      &::after{
        content:'';
        display:block;
        clear:both;
        height:0;
        visibility:hidden;
        font-size:0;
      }
      span{
        color:#999;
        display: inline-block;
      }
    }
    .fun{
      color: #999;
      &::after{
        content:'';
        display:block;
        clear:both;
        height:0;
        visibility:hidden;
        font-size:0;
      }
      .delete{
        width: 20px;
        height: 20px;
        background: url(../assets/images/icon-delete.png) no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
  .listpage{
    padding: 0 0 40px;
    text-align: center;
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background: #a11b00;
    }
  }
  &.pcList{
    overflow-y: auto;
  }
}
.pop{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: none;
  background: rgba(0,0,0,0.4);
  .popbox{
    width: 20%;
    height: 140px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -70px 0 0 -10%;
    background: #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    overflow: hidden;
    padding: 40px 20px 0;
    h2{
      font-size: 14px;
      text-align: center;
    }
    .spanbtnbox{
      position: absolute;
      width: 80%;
      left: 50%;
      bottom: 15px;
      margin-left: -40%;
      text-align: center;
      span{
        display: inline-block;
        width: 30%;
        height: 30px;
        margin: 0 5px;
        line-height: 30px;
        background: #a11b00;
        text-align: center;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        color:#fff;
        cursor: pointer;
      }
    }
  }
}
.bscroll .itemcontent{
  width: 1200px;
  margin: 0 auto;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: none;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: none;
  border-radius: 4px;
  background-color: none;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, .2);
  background-color: #ddd;
}
.drop-down{
  text-align: center;
}
@media only screen and ( max-width:768px) {
  .bscroll .itemcontent{
    width: 100%;
  }
  .bscroll{
    .itembox1 {
      ul{
        li{
          width: 25%;
        }
      }
    }
    .nodatalist{
      font-size: 14px;
    }
  }
  .pop{
    .popbox{
      width: 60%;
      margin-left: -30%;
    }
  }
}
.lstheme{
  .itemcontent{
    .itembox1{
      background: #012245;
      border: solid 1px #9fb9d0;
      box-shadow: 0 0 40px rgba(171, 222, 254, 0.5) inset;
      .info.infoborbottom{
        border-bottom: solid 2px #5298f0;
        span{
          color: #bed2ed;
        }
      }
      .txt{
        .con{
          color: #fff;
        }
        label{
          color: #5197ef;
          border: solid 1px #5197ef;
        }
      }
      .fun{
        color: #5297f2;
        .no{
          color: #f7a54f;
        }
      }
    }
  }
  .nodatalist{
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mymessage.vue